/* eslint-disable sort-keys */
export const MANAGEUSERSESSION = {
  TITLE: "Manage Users/Sessions",
  USERSTITLE: "Users",
  SESSIONSTITLE: "Sessions",
  SUCCESS: "Success",
  SEARCHUSERS: "Search Users",
  USERNAME: "User Name",
  ROLE: "Role",
  LOCKEDON: "Locked On",
  ISLOCKED: "IsLocked",
  SEARCHSESSIONS: "Search Sessions",
  SESSIONID: "Session ID",
  LOCKTOOLTIP: "Lock & Unlock",
  DIALOGMESSAGE: "Do you really want to {0} the user {1}?",
  LOCKDIALOGTITLE: "Lock",
  UNLOCKDIALOGTITLE: "Unlock",
  UNLOCK: "unlock",
  LOCK: "lock",
  SEARCHUSERID: "SearchUsers",
  MANAGEUSERSTITLE: "Manage Users",
  MANAGEUSERSSESSIONTITLE: "Manage Sessions",
  UNLOCKUSER: "Unlock User",
  LOCKUSER: "Lock User",
  UNLOCKSESSION: "Unlock Session",
  LOCKSESSION: "Lock Session",
  LOCKUSERSUCCESSMESSAGE: "User {0} successfully {1}ed",
  LOCKSESSIONSUCCESSMESSAGE: "Do you really want to {0} the user {1}",
  DIALOGSESSIONMESSAGE: "Do you really want to {0} the {1}'s session?",
  LOCKUSERSESSIONSUCCESSMESSAGE: "User{0}'s session successfully {1}ed",
  SELECTEDUSER: "selected user",
  NOROWSTEXT: "No data found",
};